import { render } from "./PanelCenterFooterMassActions.vue?vue&type=template&id=515a0308&scoped=true"
import script from "./PanelCenterFooterMassActions.vue?vue&type=script&lang=js"
export * from "./PanelCenterFooterMassActions.vue?vue&type=script&lang=js"

import "./PanelCenterFooterMassActions.vue?vue&type=style&index=0&id=515a0308&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515a0308"]])

export default __exports__